import React from 'react';
import { TConsumerItem, TSelectorRegularData } from '../../../types/data';
import { TRowOption, TSelectorRegularOption } from '../../../types/options';
import { SwitcherView } from '../../Checkbox/SwitcherView';
import { VisualView } from '../../Image/VisualView';
import { Tag } from '../Tag/Tag';

type TSelectorRegularRight = {
    uid: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    /** Design version of the widget rendering the row (`TWidget.version`). */
    version: number | undefined;
} & Pick<TSelectorRegularData, 'value'> &
    Pick<TRowOption, 'metaVariant' | 'metaHierarchy'> &
    Pick<TConsumerItem, 'metaText'> &
    Pick<TSelectorRegularOption, 'isDisabled' | 'variant'>;

export const SelectorRegularRight = ({
    version,
    uid,
    variant,
    value,
    metaText,
    metaVariant,
    metaHierarchy,
    isDisabled,
    handleChange,
}: TSelectorRegularRight) => {
    if (variant) {
        return (
            <>
                {variant === 'SWITCHER' && (
                    <div onClick={(e) => e.stopPropagation()}>
                        <SwitcherView uid={uid} isDisabled={isDisabled} isChecked={value} handleChange={handleChange} version={version} />
                    </div>
                )}
                {variant === 'CHECK' && value === true && (
                    <VisualView version={version} iconName={'ic_check'} size={'small'} iconHierarchy="emphasised" isDisabled={isDisabled} />
                )}
            </>
        );
    }
    if (metaText) {
        return <Tag metaText={metaText} metaVariant={metaVariant} metaHierarchy={metaHierarchy ?? 'secondary'} isDisabled={isDisabled} version={version} />;
    }
    return false;
};
